<template>
  <v-layout wrap>
    <v-flex v-if="loading" xs12>
      <div class="text-xs-center py-5">
        <v-progress-circular color="primary" indeterminate size="36" />
        <div class="caption grey--text text--darken-1 mt-3">
          Carregando configurações...
        </div>
      </div>
    </v-flex>

    <v-flex v-else-if="!loading && !rules" xs12>
      <v-card flat class="pa-4">
        <v-layout column align-center justify-center class="text-xs-center">
          <v-icon size="32" color="grey darken-1">mdi-file-outline</v-icon>
          <div class="body-2 grey--text text--darken-1 mt-2">
            Nenhuma regra encontrada.
          </div>
        </v-layout>
      </v-card>
    </v-flex>

    <v-flex v-else xs12>
      <v-layout row wrap>
        <v-flex v-for="ruleGroup in ruleGroups" :key="ruleGroup.key" xs12>
          <v-card class="my-2 mx-1 pa-2" tile>
            <v-card-title
              class="pa-0 title"
              :class="
                ruleGroup.key === 'with_optin'
                  ? 'green--text text--darken-2'
                  : 'red--text text--darken-2'
              "
            >
              <v-icon
                left
                class="mr-1"
                size="24"
                :color="ruleGroup.key === 'with_optin' ? 'green' : 'red'"
              >
                {{
                  ruleGroup.key === "with_optin"
                    ? "mdi-check-circle-outline"
                    : "mdi-alert-circle-outline"
                }}
              </v-icon>
              {{ ruleGroup.label }}
            </v-card-title>

            <v-card-text class="py-1 px-0">
              <v-layout d-flex row wrap>
                <v-flex
                  v-for="ruleLocation in ruleLocations"
                  :key="ruleGroup.key + '-' + ruleLocation.key"
                  xs12
                  lg6
                >
                  <v-card class="ma-2 pa-2" tile>
                    <v-card-title
                      class="pa-0"
                      :class="
                        ruleGroup.key === 'with_optin'
                          ? 'green--text text--darken-2'
                          : 'red--text text--darken-2'
                      "
                    >
                      <v-icon
                        left
                        class="mr-1"
                        size="18"
                        :color="
                          ruleGroup.key === 'with_optin' ? 'green' : 'red'
                        "
                      >
                        {{
                          ruleLocation.key === "located"
                            ? "mdi-map-search"
                            : "mdi-map-minus"
                        }}
                      </v-icon>

                      {{ ruleLocation.label }}
                    </v-card-title>

                    <v-layout
                      v-if="
                        creditorRules &&
                        creditorRules[ruleGroup.key] &&
                        creditorRules[ruleGroup.key][ruleLocation.key]
                      "
                      row
                      wrap
                    >
                      <v-flex
                        v-for="notificationCount in Object.keys(
                          creditorRules[ruleGroup.key][ruleLocation.key],
                        )"
                        :key="notificationCount"
                        style="width: 20%"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <div v-on="on">
                              <v-text-field
                                :value="
                                  creditorRules[ruleGroup.key][
                                    ruleLocation.key
                                  ][notificationCount]
                                "
                                type="number"
                                step="1"
                                box
                                :label="getLabel(notificationCount)"
                                min="1"
                                max="10"
                                class="mt-2 mr-1"
                                hide-details
                                @input="
                                  handleRuleValueInput(
                                    ruleGroup.key,
                                    ruleLocation.key,
                                    notificationCount,
                                    $event,
                                  )
                                "
                                @blur="
                                  handleRuleValueBlur(
                                    ruleGroup.key,
                                    ruleLocation.key,
                                    notificationCount,
                                    $event,
                                  )
                                "
                              />
                            </div>
                          </template>
                          <p>
                            {{ ruleGroup.label }} - {{ ruleLocation.label }}
                          </p>
                          <div
                            v-html="
                              getTooltip(
                                ruleGroup.key,
                                ruleLocation.key,
                                notificationCount,
                              )
                            "
                          ></div>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: "FormQuarentineRules",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      creditorRules: null,
      ruleGroups: [
        {
          key: "with_optin",
          label: "Com Optin",
        },
        {
          key: "without_optin",
          label: "Sem Optin",
        },
      ],
      ruleLocations: [
        {
          key: "located",
          label: "Localizado",
        },
        {
          key: "not_located",
          label: "Não Localizado",
        },
      ],
    };
  },
  computed: {
    hasRules() {
      return Boolean(this.creditorRules);
    },
  },
  watch: {
    rules: {
      immediate: true,
      deep: true,
      handler() {
        this.setupCreditorRules();
      },
    },
  },
  mounted() {
    this.setupCreditorRules();
  },
  methods: {
    setupCreditorRules() {
      if (!this.rules) return;
      this.creditorRules = this.cloneRules(this.rules);
    },
    cloneRules(value) {
      if (!value) {
        return null;
      }
      return JSON.parse(JSON.stringify(value));
    },
    getRuleEntries(ruleGroupKey, ruleLocationKey) {
      if (!this.creditorRules || !this.creditorRules[ruleGroupKey]) {
        return [];
      }

      const locationRules = this.creditorRules[ruleGroupKey][ruleLocationKey];

      if (!locationRules || typeof locationRules !== "object") {
        return [];
      }

      return Object.keys(locationRules)
        .sort((a, b) => Number(a) - Number(b))
        .map((attempt) => ({
          attempt,
          hours: locationRules[attempt],
        }));
    },
    handleRuleValueInput(ruleGroupKey, ruleLocationKey, attempt, value) {
      this.$set(
        this.creditorRules[ruleGroupKey][ruleLocationKey],
        attempt,
        value,
      );
      this.$emit("update-rules", this.creditorRules);
    },
    handleRuleValueBlur(ruleGroupKey, ruleLocationKey, attempt, event) {
      const normalizedValue = this.normalizeRuleValue(
        this.creditorRules[ruleGroupKey][ruleLocationKey][attempt],
      );
      this.$set(
        this.creditorRules[ruleGroupKey][ruleLocationKey],
        attempt,
        normalizedValue,
      );
      event.target.value = normalizedValue;
      this.$emit("update-rules", this.creditorRules);
    },
    normalizeRuleValue(value) {
      const parsedValue = Math.trunc(Number(value));
      if (!Number.isFinite(parsedValue)) return 1;
      return Math.min(10, Math.max(1, parsedValue));
    },
    getLabel(notificationCount) {
      return (
        notificationCount +
        "ª" +
        (notificationCount === "5" ? "+" : "") +
        " notificação"
      );
    },
    getTooltip(groupKey, locationKey, notificationCount) {
      let message = `
        <p>${this.creditorRules[groupKey][locationKey][notificationCount]} dia${
        this.creditorRules[groupKey][locationKey][notificationCount] == 1
          ? ""
          : "s"
      } de quarentena após a ${this.getLabel(notificationCount)}</p>
        `;
      // if (this.useDefaultConfiguration) {
      //   message += `<p>* Usando configuração padrão *</p>`;
      // }

      return message;
    },
  },
};
</script>
